import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { ChevronDown } from 'lucide-react'
import { ImageUrlInput } from '../shared/ImageUrlInput'
import type { WidgetConfiguration } from '../../types'

interface AvatarSettingsSectionProps {
  config: WidgetConfiguration
  onUpdate: (updates: Partial<WidgetConfiguration>) => void
  isOpen: boolean
  onToggle: () => void
}

export function AvatarSettingsSection({ config, onUpdate, isOpen, onToggle }: AvatarSettingsSectionProps) {
  return (
    <Collapsible open={isOpen} onOpenChange={onToggle}>
      <CollapsibleTrigger className="flex w-full items-center justify-between rounded-lg border p-4 hover:bg-accent">
        <h3 className="font-semibold">Avatar Settings</h3>
        <ChevronDown
          className={`h-4 w-4 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </CollapsibleTrigger>
      <CollapsibleContent className="pt-4 space-y-4">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="show_avatar"
            checked={config.show_avatar}
            onCheckedChange={(checked: boolean) => onUpdate({ show_avatar: checked })}
          />
          <Label htmlFor="show_avatar" className="cursor-pointer">
            Show Avatars
          </Label>
        </div>
        <p className="text-xs text-muted-foreground">
          Display avatar images next to messages
        </p>

        <ImageUrlInput
          label="Assistant Avatar URL"
          value={config.assistant_avatar_url}
          onChange={(url) => onUpdate({ assistant_avatar_url: url })}
          description="Image shown for assistant messages"
        />

        <ImageUrlInput
          label="User Avatar URL"
          value={config.user_avatar_url}
          onChange={(url) => onUpdate({ user_avatar_url: url })}
          description="Default image for user messages"
        />

        <ImageUrlInput
          label="Profile Icon URL"
          value={config.profile_icon_url}
          onChange={(url) => onUpdate({ profile_icon_url: url })}
          description="Icon shown in the chat header"
        />
      </CollapsibleContent>
    </Collapsible>
  )
}
